const theme = {
  colors: {
    primaryBlue: '#1c62ef',
    primaryBlueLight: '#679CEF',
    primaryBlueDark: '#0039BB',
    darkViolet: '#2C2B48',
    primaryViolet: '#4F5388',
    mediumBlue: '#679CEF',
    lightBlue: '#CADFFC',
    grey: '#ECEFF1',
    greyDark: '#BABDBE',
    gray2: '#4f4f4f',
    secondaryLight: '#C4C4C4',
    analogousPurple: '#3F1CEF',
    analogousBlue: '#1CCCEF',
    complimentaryYellow: '#EFA91C',
    triadicPink: '#A91CEF',
    triadicRed: '#EF1C62',
  },
  space: [0, 4, 8, 16, 32, 64],
  breakpoints: ['576px', '768px', '992px', '1200px', '1440px'],
}

export default theme;